import { createSlice } from "@reduxjs/toolkit";
import { api } from "../../services/api";

const initialState = {
  otherDetails: null,
  projectSummary: null,
  recentProjects: [],
  deploymentHistory: [],
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setOtherDetails: (state, action) => {
      state.otherDetails = action.payload;
    },
    setProjectSummary: (state, action) => {
      state.projectSummary = action.payload;
    },
    setRecentProjects: (state, action) => {
      state.recentProjects = action.payload;
    },
    setDeploymentHistory: (state, action) => {
      state.deploymentHistory = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setOtherDetails,
  setProjectSummary,
  setRecentProjects,
  setDeploymentHistory,
} = dashboardSlice.actions;

// Thunk actions
export const fetchDashboardData = () => async (dispatch, getState) => {
  try {
    const org_id = getState().org?.active?.id;
    if (!org_id) {
      throw new Error("Organization ID not found");
    }

    const params = { org_id };
    const [otherDetails, projectSummary, recentProjects, deploymentHistory] =
      await Promise.all([
        api("get", "dashboard/other-details", null, {}, params),
        api("get", "dashboard/projects-summary", null, {}, params),
        api("get", "dashboard/recent-projects", null, {}, params),
        api("get", "dashboard/deployment-history", null, {}, params),
      ]);

    if (otherDetails.success) dispatch(setOtherDetails(otherDetails.data));
    if (projectSummary.success)
      dispatch(setProjectSummary(projectSummary.data));
    if (recentProjects.success)
      dispatch(setRecentProjects(recentProjects.data));
    if (deploymentHistory.success)
      dispatch(setDeploymentHistory(deploymentHistory.data));
  } catch (error) {
    dispatch(setError(error.message));
  } finally {
  }
};

export default dashboardSlice.reducer;
